import { useContext, useEffect, useState } from "react";
import LoginContext from "./hooks/loginContext";
import SubTask from "./pages/Tasks/Task/sub-task";
import TaskList from "./pages/Tasks/task-list";
import FirstLoginScreen from "./pages/Login/NewUser";
import Task from "./pages/Tasks/Task/task";
import WelcomePage from "./pages/Welcome/WelcomePage";
import LoginScreen from './pages/Login/Login';
import { Dimensions, StyleSheet } from "react-native";
import { tasks } from "./utils/tasks";
import QualityCheck from "./pages/Tasks/Task/quality-check";

let ScreenHeight = Dimensions.get('window').height;

export const Router = () => { 

    const [index, setIndex] = useState(0);
    const [task, setTask] = useState(null);
    const {setUser} = useContext(LoginContext)
  
    useEffect(() => {
      const user = JSON.parse(localStorage.getItem('user'));
      if (user && index<=2) {
        setUser(user);
        setIndex(3);
      }
      else {
        setIndex(0)
      }
    },[])
    
    
    switch (index) {
      case 0: return <LoginScreen setIndex={setIndex} />
      case 1: return <FirstLoginScreen setIndex={setIndex} />
      case 2: return <WelcomePage setIndex={setIndex} />
      case 3: return <TaskList setTask={setTask} setIndex={setIndex} />
      case 4: return <SubTask setIndex={setIndex} task={task} />
      case 5: return <QualityCheck setIndex={setIndex}/>
      case 6: return <Task task={task} setIndex={setIndex} />
    }
  }
  
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      height: ScreenHeight,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#F5FCFF'
    },
    header: {
      padding: 20
    },
    title: {
      fontWeight: 'bold',
      fontSize: '1.5rem',
      marginVertical: '1em',
      textAlign: 'center'
    },
    text: {
      lineHeight: '1.5em',
      fontSize: '1.125rem',
      marginVertical: '1em',
      textAlign: 'center'
    },
    link: {
      color: '#1B95E0'
    },
    code: {
      fontFamily: 'monospace, monospace'
    }
  });